import React, {Component} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';


export default class ChangePassword extends Component {
  constructor(props){
    super(props);
    this.state={
      oldPassword: '',
      password: ''
    }
  }
  handleOldPasswordChange = (oldPassword) => this.setState({oldPassword});
  handleChange = (password) => this.setState({password});
  changePassword = () =>{
    const {oldPassword, password} = this.state;
    if(oldPassword.length < 1) {
      alert("Please enter your current password");
      return;
    }
    if(password.length >= 6) {
      this.props.changePassword({
        oldPassword,
        password
      });
    } else {
      alert("New password must be at least 6 characters")
    }
  }
  render(){
    const {oldPassword, password} = this.state;
    return(
      <Dialog
        open={true}
        onClose={this.props.closeChangePassword}
      >
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent style={{paddingTop: 16}}>
          <TextField
            label="Current Password"
            type="password"
            value={oldPassword}
            size="small"
            variant="standard"
            fullWidth
            required
            style={{marginBottom: 16}}
            onChange={(e)=>{this.handleOldPasswordChange(e.target.value)}} />
          <TextField
            label="New Password"
            type="password"
            value={password}
            size="small"
            variant="standard"
            fullWidth
            required
            onChange={(e)=>{this.handleChange(e.target.value)}} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.closeChangePassword}>Cancel</Button>
          <Button onClick={this.changePassword} variant='contained'>Save</Button>
        </DialogActions>
      </Dialog>
    )
  }
}
